import { Component, Type } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps } from '@ngx-formly/core';

interface ExpansionPanelProps extends CoreFormlyFieldProps {
    expanded?: boolean;
}

export interface FormlyExpansionPanelFieldConfig extends FormlyFieldConfig<ExpansionPanelProps> {
    type: 'kendo-expansionpanel' | Type<FormlyWrapperExpansionPanel>;
}

@Component({
    selector: 'formly-wrapper-kendo-expansionpanel',
    template: `
        <kendo-expansionpanel [title]="props.label" [expanded]="props.expanded === true">
            <ng-container #fieldComponent></ng-container>
        </kendo-expansionpanel>
    `
})
export class FormlyWrapperExpansionPanel extends FieldWrapper<FormlyFieldConfig<ExpansionPanelProps>> { }
